<template id="vue-challenge-section-container">
    <div class="challenge-section-container" v-bind:key="this.swiperOption.slidesPerView">
        <div class="title" v-if="title">
          <a v-bind:href="'#' + trimTitle" v-bind:id="trimTitle" v-bind:ref="trimTitle">
            <h2 >{{title}}</h2>
            <span class="tooltip" v-if="tooltipText" @click="toggleTooltip" @mouseover="showTooltip" @mouseleave="hideTooltip">
                <i class="tooltip-nyop fa fa-question-circle" v-tooltip="tooltipOptions"></i>
            </span>
          </a>
        </div>

        <swiper :options="swiperOption">
            <slot></slot>
            <div class="swiper-button-prev" slot="button-prev" @click="preventDefault"></div>
            <div class="swiper-button-next" slot="button-next" @click="preventDefault"></div>
        </swiper>
    </div>
</template>

<script>
export default {
  template: '#vue-challenge-section-container',
  props: ['title', 'tooltipText', 'isBigContainer'],
  data: function() {
    return {
      windowWidth: window.innerWidth,
      tooltipOptions: {
        content: this.tooltipText,
        trigger: 'manual',
        show: false
      }

    }
  },
  computed: {
    swiperOption: function() {
      return {
        slidesPerView: smartSlidesPerViewCalculator(this.isBigContainer, this.windowWidth),
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    },
    trimTitle: function() {
      return this.title.toLowerCase().replace(/\s/g, '_');
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  mounted: function() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  methods: {
    handleWindowResize: function(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
    toggleTooltip: function (event) {
      event.preventDefault();
      this.tooltipOptions.show = !this.tooltipOptions.show;
    },
    showTooltip: function () {
      this.tooltipOptions.show = true;
    },
    hideTooltip: function () {
      this.tooltipOptions.show = false;
    },
    preventDefault: function (event) {
      event.preventDefault();
    }
  }
}

function smartSlidesPerViewCalculator(isBigContainer, windowWidth) {
  var slides = 3;
  if (windowWidth < 1000) slides = 1.3;
  if (isBigContainer) slides = 1;

  return slides;
}

</script>
